import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import "./ImpactStats.css";

const ImpactStats = () => {
  const [hasAnimated, setHasAnimated] = useState(false);

  const stats = [
    {
      figure: 750,
      suffix: "+",
      label: "Community Members Reached",
    },
    {
      figure: 100,
      suffix: "+",
      label: "Qualifications Achieved",
    },
    {
      figure: 45,
      suffix: "+",
      label: "People Prepared into Employment",
    },
    {
      figure: 5,
      suffix: "",
      label: "London Boroughs Covered",
    },
  ];

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setHasAnimated(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="impact-stats-home">
      <div className="impact-stats-home-header">
        <h2>Our Impact</h2>
        <p className="impact-stats-home-subtitle">
          2024-2025 · Real outcomes for real people across East London
        </p>
      </div>

      <div className="impact-stats-home-grid">
        {stats.map((stat, index) => (
          <div key={index} className="impact-stat-card">
            <VisibilitySensor partialVisibility offset={{ bottom: 50 }}>
              {({ isVisible }) => (
                <div className="impact-stat-number">
                  {isVisible || hasAnimated ? (
                    <>
                      <CountUp 
                        end={stat.figure} 
                        duration={2} 
                        start={0}
                        useEasing={true}
                      />
                      {stat.suffix}
                    </>
                  ) : (
                    <>{stat.figure}{stat.suffix}</>
                  )}
                </div>
              )}
            </VisibilitySensor>
            <p className="impact-stat-label">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="impact-stats-home-cta">
        <Link to="/about/our-impact" className="impact-stats-home-link">
          See our full impact report
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default ImpactStats;
